import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function useUserNotifications() {
  const staleTime = 1000 * 60; //60 seconds
  const queryClient = useQueryClient();
  const {
    user: { user }
  } = useUserContext();
  const { get, post, put, del } = useApiHelper();

  const notifications = useQuery(["notifications", user.id], () => get(`/Notification/all/${user.id}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const recentNotifications = useQuery(["notifications", user.id, "recent"], () => get(`/Notification/recent/${user.id}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const unseen = useQuery(["notifications", user.id, "unseen"], () => get(`/Notification/unseen/${user.id}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const markSeen = useMutation(
    (notificationIds) => put(`/Notification/markallseen`, notificationIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notifications", user.id])
      },
    }
  );

  const markRead = useMutation((notificationId) => put(`/Notification/${notificationId}/markread`, notificationId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notifications", user.id])
      },
    }
  );

  const markAllRead = useMutation(
    (notificationIds) => put(`/Notification/markallread`, notificationIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notifications", user.id])
      },
    }
  );

  // const update = useMutation((notification) => put(`/Notification/${notification.id}`, notification),
  //   {
  //     onSuccess: (updatedNotification) => {
  //       queryClient.setQueryData(["notifications", user.id], (currentNotifications) =>
  //         currentNotifications.map((notification) =>
  //           notification.id === updatedNotification.id ? updatedNotification : notification
  //         )
  //       );
  //     },
  //   }
  // );

  return {
    notifications,
    recentNotifications,
    unseen,
    markSeen,
    markRead,
    markAllRead,
  };
}
